<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'

export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise(resolve => {
          this.$sdk
            .pickup
            .read(this.$route.params.pickupId)
            .then((response) => {
              resolve(response.booking_reference)
            })
        }),
        route: { name: 'customerservice-accounts-account-pickups-pickup', params: this.$route.params }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'file-invoice'],
          route: { name: 'customerservice-accounts-account-pickups-pickup-details', params: this.$route.params },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'sticky-note'],
          route: { name: 'customerservice-accounts-account-pickups-pickup-notes', params: this.$route.params },
          name: 'Notes'
        }
      ]
    }
  }
}
</script>
